module.exports = __webpack_public_path__ + "static/media/leeds-wall-paper.76711d2a.jpg";